export const pixabayConstants = {
    api_url: 'https://pixabay.com/api',
    api_key: '11112624-06f0eb3bbe7a5b94cf0b551b8', //Please change with your API Key
    item_count_per_page: 24
};